import { createFileRoute, Outlet } from '@tanstack/react-router';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { useTenantFeatureFlags } from '@/lib/hooks/use-tenant-feature-flags';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';
import { Machines } from '@/pages/machines';

export const machinesSearchSchema = commonSearchSchema.extend({
  /** Pannello Filtri (stessi nomi dell'API); la vista rapida è `?tab=`. */
  companyId: optionalSearchString(),
  statuses: optionalSearchString(),
  due: optionalSearchString(),
  includeArchived: optionalSearchBoolean(),
  /** Scheda della macchina aperta (`?section=`). */
  section: optionalSearchString(),
  /** Cliente proposto nella creazione (`/new?customerId=`). */
  customerId: optionalSearchString(),
});

export const Route = createFileRoute('/protected/_layout/machines/_layout')({
  validateSearch: machinesSearchSchema,
  component: MachinesLayout,
});

/** Sezione visibile con il permesso E il modulo Macchine del tenant. */
function MachinesLayout() {
  const { canAccessMachines, isLoading } = usePermissions();
  const { isMachinesEnabled, isLoading: isLoadingFlags } =
    useTenantFeatureFlags();
  return (
    <RoleGuard
      hasAccess={canAccessMachines && isMachinesEnabled}
      isLoading={isLoading || isLoadingFlags}
    >
      <Machines />
      <Outlet />
    </RoleGuard>
  );
}
